import { render } from "./Section_Payables.vue?vue&type=template&id=11f565be"
import script from "./Section_Payables.vue?vue&type=script&lang=js"
export * from "./Section_Payables.vue?vue&type=script&lang=js"

import "./Section_Payables.vue?vue&type=style&index=0&id=11f565be&lang=css"
script.render = render

export default script